import axios from "axios";
import { objToFormData } from "utils/helperFunctions";
import Cookies from "js-cookie";

function objToFormDataConverter(data) {
  let formData;
  if (data instanceof FormData) {
    formData = data;
  } else if (typeof data == "object") {
    formData = objToFormData(data);
  } else if (data == undefined) {
    formData = new FormData();
  } else {
    // formData = data;
  }
  // formData.append("user_token", "UpoKj*12*VLMagUSEGBRGP2sQ*14**14*");
  formData.append("token", Cookies.get("token"));
  return formData;
  // to do: add user token from cookie
}
export function sendRequestAPIMain(functionName, data) {
  let formData = objToFormDataConverter(data);
  return axios.post(
    `http://cryptozoom.tatdemo.ir/apimain/${functionName}`,
    formData
  );
}
export function sendRequestAPI(functionName, data) {
  let formData = objToFormDataConverter(data);
  return axios.post(
    `http://cryptozoom.tatdemo.ir/api/${functionName}`,
    formData
  );
}
export function sendRequestAPI2(functionName, data) {
  let formData = objToFormDataConverter(data);
  return axios.post(
    `http://cryptozoom.tatdemo.ir/api2/${functionName}`,
    formData
  );
}
